/* eslint-disable */
import merchant from "./data";

const state = {
  loadingCount: 0,
  list: [],
  edit: {},
  errorMsg: ""
};

// getters
const getters = {
  loading(state) {
    return state.loadingCount === 0;
  }
};

// actions
const actions = {
  init: context => {
    context.commit("SET_LOADING", true);
    return merchant
      .list(context)
      .then(data => {
        context.commit("SET_LIST", data.results);
        return data.results;
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  get: (context, merchantID) => {
    context.commit("SET_LOADING", true);
    return merchant.get(context, merchantID).finally(() => {
      context.commit("SET_LOADING", false);
    });
  },
  getLocations: (context, merchantID) => {
    context.commit("SET_LOADING", true);
    return merchant.locations.get(context, merchantID)
    .finally(() => {
      context.commit("SET_LOADING", false);
    });
  },
  insertLocation: (context, location) => {
    context.commit("SET_LOADING", true);
    return merchant.locations.insert(context, location).finally(() => {
      context.commit("SET_LOADING", false);
    });
  },
  update: (context, updatedMerchant) => {
    context.commit("SET_LOADING", true);
    return merchant.update(context, updatedMerchant).finally(() => {
      context.commit("SET_LOADING", false);
    });
  },
  delete: (context, merchantID) => {
    context.commit("SET_LOADING", true);
    return merchant.delete(context, merchantID).finally(() => {
      context.commit("SET_LOADING", false);
    });
  },
  insert: (context, newMerchant) => {
    context.commit("SET_LOADING", true);
    return merchant.insert(context, newMerchant).finally(() => {
      context.commit("SET_LOADING", false);
    });
  }
};

// mutations
const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  },
  SET_LOADING(state, loading) {
    state.loadingCount += loading ? 1 : -1;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
